import dayjs from 'dayjs';
import { QUERY_GET_NOTIFICATIONS } from '@/graphql/cursor.graphql';
import { GetAllNotificationV2Query, GetAllNotificationV2QueryVariables, SortEnum } from '@/types/generated/graphql';
import { useLazyCursorPagination } from '@shared/hooks/use-lazy-cursor-pagination';

export function useGetNotification() {
  const notifications = useLazyCursorPagination<GetAllNotificationV2Query, GetAllNotificationV2QueryVariables>({
    schema: QUERY_GET_NOTIFICATIONS,
    responseDataKey: 'getAllNotificationV2',
    variables: {
      sort: SortEnum.DESC,
    },
  });
  const notificationList = notifications?.data?.data ?? [];
  const sortedNotifications = [...notificationList]?.sort((a, b) => {
    const shouldSwap = dayjs(b?.createdAt).isAfter(dayjs(a?.createdAt));

    if (shouldSwap) {
      return 1;
    } else {
      return -1;
    }
  });

  return {
    ...notifications,
    data: {
      ...notifications?.data,
      data: sortedNotifications,
    },
  };
}
